import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jrqmafjzaouqssgmbetu.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpycW1hZmp6YW91cXNzZ21iZXR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1OTU1NjksImV4cCI6MjA5MTE3MTU2OX0.aT4hFOgLJwmfi65ako5it5r0WRFe7gthvAdezATreWc'

export const supabase = createClient(supabaseUrl, supabaseKey)

supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'PASSWORD_RECOVERY' && session?.access_token) {
    sessionStorage.setItem('recovery_access_token', session.access_token)
    sessionStorage.setItem('recovery_refresh_token', session.refresh_token || '')
    sessionStorage.setItem('etern_recovery', 'true')
    console.log('Recovery capturado en supabase.js:', session.user?.email)
  }
})